/**
 * JOB Schedule Value Not String
 */
export default ['jobScheduleList', 'jobNames', 'index', 'type', 'scheduleType', 'status'];
